const accessPurchase = {

    VENDOR_LIST: { name: 'Vendor', path: '/vendor-list' },
    ADD_VENDOR: { name: 'Create Vendor', path: '/create-vendor' },
    UPDATE_VENDOR: { name: 'Edit Vendor', path: '/edit-vendor' },
    DELETE_VENDOR: { name: 'Delete Vendor', path: '/delete-vendor' },

}

export default accessPurchase;